"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _withIconProps = require("../utils/withIconProps");
var _react2 = require("@emotion/react");
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

const IconAlertTriangleFillMedium = (0, _withIconProps.withIconProps)(props => {
  return (0, _react2.jsx)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), (0, _react2.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12.3632 2 12.6978 2.19689 12.8742 2.51436L22.8742 20.5144C23.0462 20.8241 23.0416 21.2017 22.8619 21.5071C22.6822 21.8125 22.3543 22 22 22H2C1.64568 22 1.31781 21.8125 1.13813 21.5071C0.958444 21.2017 0.95377 20.8241 1.12584 20.5144L11.1258 2.51436C11.3022 2.19689 11.6368 2 12 2ZM12 7C12.5523 7 13 7.44772 13 8V15.0001C13 15.5523 12.5523 16.0001 12 16.0001C11.4477 16.0001 11 15.5523 11 15.0001V8C11 7.44772 11.4477 7 12 7ZM13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19Z",
    fill: "currentColor"
  }));
}, 'IconAlertTriangleFillMedium');
IconAlertTriangleFillMedium.displayName = 'IconAlertTriangleFillMedium';
var _default = exports.default = IconAlertTriangleFillMedium;